<template>
  <div class="app-content content devcontent ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
            <div class="container-fluid">
                <div class="row breadcrumbs-top">
                  <div class="col-md-12 content-header-left px-0">
                    <h3 class="content-header-title float-left mb-0" >Fleet   </h3>
                    
                    <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Dashboard</a>
                                </li>
                                
                                
                                
                                
                            </ol>
                        </div>
                  </div>
                </div>
            </div>
            
        </div>
        <div class="card content-body" style="border-radius: 16px;">
            <section class="p-0  main_route_traking_map" >
                    <div class="container px-0">
                        
                        <div class="map_image_full">
                            <img alt="" src="../../public/images/icons/dashboard002.png" class="img-fluid">
                        </div>
                    </div>
                </section>
        </div>
      <div class="card content-body" style="display: none;">
        <div class="card-header px-0  common_top_title_searchbgst_dock">
                    <div class="container-fluid " >
                        <div class="row row fc_my-05">
                            <div class="w-auto px-1 mobile-padding-0-2">
                                <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                    <div class="avatar-content">
                                        <em class="las la-home i_icon_st font-medium-5"></em>
                                        
                                    </div>
                                </div>
                                
                                <h4 class="card-title d-inline-flex ml-0 mb-0">Fleet Dashboard</h4>
                            </div>
                        </div>    
                            
                    </div>
                </div>
          <section class="p-1 main_route_traking_map">
            <div class="row">
                <div class="col-md-4 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-0 px-0">
                        <div class="card-header bg-white flex-column align-items-start">
                            <h4 class="card-title mb-75">Fleet Status</h4>
                            
                        </div>
                        <div class="card-body py-3">
                            <div id="donut-chart"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-0 px-0">
                        <div class="card-header bg-white d-flex flex-sm-row flex-column justify-content-md-between align-items-start justify-content-start">
                                    <div>
                                        <h4 class="card-title mb-25">Fleet Usage</h4>
                                        
                                    </div>
                                    <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
                                        <div class="fleet_use">
                                        <div class="fleet_useone"> 
                                            <span class="font-weight-normal mb-0 mr-1">Total Fleet Usage</span>
                                            <span class=" badge-light-secondary text-primary">
                                                <span class="align-middle">25800 km</span>
                                            </span>
                                        </div>
                                        <div class="fleet_useone"> 
                                            <span class="font-weight-normal mb-0 mr-1">Avg. Distance Vehicle</span>
                                        <span class=" badge-light-secondary text-primary">
                                            <span class="align-middle">129 km</span>
                                        </span>
                                        </div>
                                       
                                    </div>
                                    </div>
                                    
                                </div>
                                <p class="mb-0" style="padding: 0px 8px;"> Distance</p>
                                <div class="card-body px-0">
                                    
                                    <div id="line-chart"></div>
                                </div>
                    </div>
                </div>
               
                <div class="col-md-4 col-sm-6 col-12 mb-2 mb-md-0">
                    <div class="card card_route_traking_map py-0 px-1">
                        <div class="card-header bg-white flex-column align-items-start">
                            <h4 class="card-title mb-75">Fleet Idle</h4>
                            
                        </div>
                        <div class="fleetdiv_two row">
                            <div class="col-sm-6 fleet_inner_two">
                                <p class="mb-0" >Total Fleet Idle</p>
                                <div class="media py-1">
                                    
                                    <div class="avatar bg-light-primary  card_route_traking_icons_icon">
                                        <div class="avatar-content">
                                            <img alt="" src="../../public/images/icons/frontal-truck_1.png"  height="40px" class="">
                                        </div>
                                    </div>
                                    <div class="media-body my-auto d-flex">
                                        <h4 class="font-weight-bolder mb-0 ">32</h4>
                                        <p class="card-text font-small-3 mb-0">Sales</p>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-sm-6 fleet_inner_two">
                                <p class="mb-0">Aprox Fuel waste</p>
                                <div class="media py-1">
                                    
                                    <div class="avatar bg-light-primary  card_route_traking_icons_icon ">
                                        <div class="avatar-content">
                                            <img alt="" src="../../public/images/icons/pump_petrol.png"  height="40px" class="">
                                        </div>
                                    </div>
                                    <div class="media-body my-auto d-flex">
                                        <h4 class="font-weight-bolder mb-0">84</h4>
                                        <p class="card-text font-small-3 mb-0">ltr</p>
                                    </div>
                                </div>
                               
                            </div>
                           
                        </div>
                        <p class="fleet_inner_pra"> Note: Generally, idiling vehicle uses somewehre beetwwen 1.89 to 2.64 ltr of fuel per hour</p>
                     
                       
                    </div>
                    <div class="card card_route_traking_map py-2 px-1">
                        <div class="media">
                            <div class="avatar bg-light-primary  card_route_traking_icons mr-2">
                                <div class="avatar-content">
                                    <em class="las la-truck font-medium-5"></em>
                                </div>
                            </div>
                            <div class="media-body my-auto">
                                <p class="card-text font-small-3 mb-0">Total Distance</p>
                                <h4 class="font-weight-bolder mb-0">2000 km</h4>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
          </section>
      </div>
    </div>
  </div>
</template>
<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import VueElementLoading from 'vue-element-loading'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"
import Treeselect from '@riophae/vue-treeselect'
export default {
  name: "fleetDashboard",
  mixins: [common_methods, searchMasterNameList],
  data() {
    return {
      map: null,
    };
  },
  components: {
    MarkerClusterer,
    Treeselect,
  },
  mounted() {
    
  },
  methods: {
  
    
  },
};
</script>

<style scoped>


</style>